import {
  BudgetImage,
  CommunicationImage,
  DashboardImage,
  PerformanceImage,
  QualityAssuranceImage,
  ReportingImage,
  DevelopersProcurementImage,
} from "assets/images";
import { Feature } from "components/containers/constant";

export const lenderFeature: Feature[] = [
  {
    name: "Dashboard",
    image: DashboardImage,
    description:
      "Deploy capital to build projects, with tools that lower risk, increase efficiency, enhance oversight, and ensure stakeholder accountability.",
  },
  {
    name: "Performance Tracking",
    image: PerformanceImage,
    description:
      "Smart charts to track project plans to ensure timely delivery",
  },
  {
    name: "Budget Tracking",
    image: BudgetImage,
    description:
      "Follow the money! Gain complete visibility and control of project finance.",
  },
    {
    name: "Procurement Management",
    image: DevelopersProcurementImage,
    description:
      "Get granular details of material procurement and consumption on projects.",
  },

  {
    name: "Communication",
    image: CommunicationImage,
    description:
      "Keep every stakeholder in the loop with real time communication and reporting.",
  },
  {
    name: "Quality Assurance",
    image: QualityAssuranceImage,
    description:
      "Ensure every task is delivered to specification with our robust quality assurance checklist and approval system.",
  },
  {
    name: "Reporting",
    image: ReportingImage,
    description:
      "Eliminate hours of writing, automate reports to stakeholders.",
  },
];
